import { ReactElement, useEffect } from "react";
import * as Api from "../../../../api";
import store from "../../../../redux/store";
import { _setConfiguration } from "../../../../redux/slices/tenantSlice";
import { useDispatch } from "react-redux";

const SettingsHandler: React.FC<any> = (props): ReactElement => {
  const dispatch = useDispatch();

  const tenantId = store?.getState()?.tenant?.selectedTenant?.id;

  useEffect(() => {
    if (tenantId) {
      _fetchJDFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  async function _fetchJDFields() {
    try {
      const { config } = await Api.getSourcingConfiguration("jd_creation_fields");
      dispatch(_setConfiguration({ sourcing_jd_fields: config ?? [] }));
    } catch (error) {
      console.error("Error fetching jd fields");
    }
  }

  return <>{props.children}</>;
};

export default SettingsHandler;
